import { Controller, UseFormReturn } from "react-hook-form";
import { InputField } from "../DynamicFormTypes";
import { LassoTextField } from "../../LassoTextField";

type Props = {
    field: InputField;
    form: UseFormReturn;
}

const TextFieldInput = ({ field, form }: Props) => {
    const { name, type, label, required = false, validationRules, defaultValue, placeholder = "" } = field;
    const { errors } = form.formState;

    return (
        <Controller
            control={form.control}
            name={name}
            rules={validationRules}
            defaultValue={defaultValue}
            render={({ field }) =>
                <LassoTextField
                    type={type}
                    label={label}
                    placeholder={placeholder}
                    fullWidth
                    required={required}
                    error={name in errors}
                    helperText={errors?.[name]?.message as string || ""}
                    {...field}
                />}
        />
    );
}

export default TextFieldInput;